module.exports = __webpack_public_path__ + "ede06df70b81e95d94c2e66bfaf020f3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-19.png
// module id = 3178
// module chunks = 0